export const TEST_IDS = {
  issueBody: 'issue-body',
  bodyLoading: 'body-loading',
  markdownBody: 'markdown-body',
  markdownEditor: (postFix = '') => `markdown-editor-${postFix}`,
  editIssueBodyButton: 'edit-issue-body-button',
}
